import StandardTabPanel from "../../../../components/ui library/components/tab-panels/standard/StandardTabPanel";
import { TAB_STYLES } from "../../../ui library/components/tab-panels/standard/tab-header/tab-styles";

export default function Navigation({ _case, activeTab, children }) {
  const allTabs = [
    {
      key: "client-info",
      name: "Client Info",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case.id}/client-info/personal`,
    },
    {
      key: "actionable-items",
      name: "Actionable Items",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case.id}/actionable-items`,
    },
    {
      key: "medical",
      name: "Medical",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case.id}/medical/providers`,
    },
/*     {
      key: "documents",
      name: "Documents",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case.id}/documents/folders`,
    }, */
    {
      key: "case",
      name: "Case",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case.id}/case/summary`,
    },
    {
      key: "contacts",
      name: "Contacts",
      isDisabled: true,
      permission: null,
      href: `/client-detail/${_case.id}/contacts/healthnsync`,
    },
  ];

  return (
    <div className="flex flex-col items-stretch flex-1 h-full transparent shadow-[3px_3px_10px_0px_rgb(188,209,255)] rounded-[15px]">
      <StandardTabPanel activeTab={activeTab} tabList={allTabs} headerTabSx={TAB_STYLES.TAB.SX} headerTabIndicatorSx={TAB_STYLES.TAB.TAB_INDICATOR_SX} >
        {children}
      </StandardTabPanel>
    </div>
  );
}